/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * UI domain - Connection status display with status text and visual indicator
 * connection.ui.client.tsx - React hybrid connection status component
 */

import { useGameState } from "@game/state";
import { useEffect } from "react";

/**
 * React component for connection status
 */
export function ConnectionComponent() {
  const { connectionStatus, isConnected } = useGameState((state) => ({
    connectionStatus: state.connectionStatus,
    isConnected: state.isConnected,
  }));

  useEffect(() => {
    const labelEl = document.getElementById("connection-label");
    const dotEl = document.getElementById("connection-dot");

    if (labelEl) {
      labelEl.textContent = isConnected ? "ONLINE" : "OFFLINE";
    }

    if (dotEl) {
      dotEl.className = isConnected
        ? "status-dot connected"
        : connectionStatus === "ERROR"
          ? "status-dot error"
          : "status-dot disconnected";
    }
  }, [connectionStatus, isConnected]);

  return null;
}

/**
 * Initialize connection status UI component
 */
export function initializeConnectionStatus(): void {
  // React handles DOM element management
}
